import { List, ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import ferryIconSource from "../../assets/ferry.svg"
import { Ferry } from "../../services/RuteplanAPI";

export default function Ferries(props: IRoutePartProps) {
    
    return (
        <>
            {props.roadFeatures && props.roadFeatures.ferger && props.roadFeatures.ferger.length > 0 &&
            <List>
                {props.roadFeatures.ferger.map( (ferge: Ferry, index: number) => ( 
                    <ListItem 
                    key={ferge.id + index} 
                    className="roadFeature" 
                    onClick={(event) => {props.onClick(ferge, event)}}
                    onMouseEnter={() => props.onMouseEnterItem(ferge)}
                    onMouseLeave={props.onMouseLeaveItem}>
                        <img src={ferryIconSource} height="24" style={{paddingRight:"5px"}} alt="ferje icon" title="ferjeIcon"/>
                        Ferje: {ferge.navn}
                    </ListItem>
                ))}            
            </List>
            }
        </>
    ) 
}